// Dataset content eras, from the page-migration plan (PLAN.md → "Data eras").
// Each era is a distinct capture pipeline with its own schema/granularity —
// not just a naming change — so the boundaries are real discontinuities in
// what the archive contains. Month-precise; the last era is open-ended and
// clamps to the chart's latest month at render time. Eras tile contiguously,
// so a bar's right edge is the next era's start.

export interface EraBand {
  label: string;
  start: string; // "YYYY-MM", inclusive
  end?: string; // "YYYY-MM", inclusive; omit for the open-ended current era
  note?: string; // shown on hover
}

export const DATASET_ERAS: EraBand[] = [
  {
    // Lines Era. No Pages exist here — sparse/discontinuous early coverage,
    // backfilled to Glacier in 2013. Deferred to migration Phase 7.
    label: "Pre Pagefeed",
    start: "2007-01",
    end: "2012-09",
    note: "Lines era — no Pages; sparse early coverage",
  },
  {
    // Standardized Pages{YYYYMMDDHHMMSS}.zip per-broadcast captures.
    label: "Page Feed",
    start: "2012-10",
    end: "2023-11",
    note: "Pagefeed era — standardized per-broadcast Pages",
  },
  {
    // Same Pages plus a per-Page is-ad classification field.
    label: "AdAware Page Feed",
    start: "2023-12",
    note: "Ad-Aware Pagefeed era — Pages + is-ad classification",
  },
];
